module.exports = __webpack_public_path__ + "img/9788952771605.f3785e44.jpg";